import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';

type CampaignLocaleSwitcherProps = {
  hideErrorCount?: boolean;
};

export const CampaignLocaleSwitcher = ({ hideErrorCount = false }: CampaignLocaleSwitcherProps) => {
  return <LocaleSwitcher isReadOnly={true} hideErrorCount={hideErrorCount} />;
};
